import React, { useEffect, useState } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";

import "./style/style.scss";
import "./style/animation.scss";
import Arrow from "./arrow";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import bild_zone_pitch from "../../../assets/wc/videos/output.webm";
import ArrowFirst from "./newArrows/arrow_one";
import ArrowSecond from "./newArrows/arrow_second";
import ArrowThird from "./newArrows/arrow_third";

const getMainBackground = () => {
  return assets.background_1920;
};

export default function Index({ animation, data, mode, format, ...props }) {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const { t } = useTranslation();

  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;

  const { optaMatchInfo: matchInfo, matchDetails, attackingZones, teamSide } =
    data?.data?.dynamic || {};
  const { matchStatus, scores } = matchDetails || {};

  const backgroundImage = getMainBackground(format, teamSide);


  const competitionId = matchInfo?.competition?.id
  const homeTeam = matchInfo?.contestant?.[0];
  const awayTeam = matchInfo?.contestant?.[1];
  const isTimeline = props.isTimeline;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };
  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name
        });
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const team = teamSide === "home" ? homeTeam : awayTeam;
  const bildMatch = data?.data?.dynamic?.matchInfo;
  const bildhomeTeam = bildMatch?.home;
  const bildawayTeam = bildMatch?.away;


  return (
    <div
      id={id}
      className={`T_${templateName} ${animation ? "animation" : ""} side-${teamSide}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("AttackingZonesHeadline", { keyPrefix: "templates" })}
            </div>
            <MatchScoreWidget
              homeTeam={bildhomeTeam}
              awayTeam={bildawayTeam}
              matchInfo={bildMatch}
            />
          </div>
        }
        <div className="wc-content wc-content-v2">
          <ProgressBar height="8px" />

          <div className="main-content-side">
            <div className={"left-block-side"}>
              <div className="teams-block">
                <div className={`team-logo-container ${teamSide}`}>
                  <Image
                    className="team-logo"
                    src={getDynamicLogoPath({ team: team, competitionId })}
                  />
                </div>
                <div className={`team-name ${teamSide}`}>
                  {t(team?.name, {
                    ns: "countries",
                  })}
                </div>
              </div>
              <div className="left-block-shadow"></div>
            </div>

            <div className={"center-block-side"}>
              <div
                className={`attacking-zones`}
              >
                <video
                  className="video-pitch"
                  width="100%"
                  height="100%"
                  controls={false}
                  muted={true}
                  autoPlay={false}
                  loop={false}>
                  <source src={bild_zone_pitch} type="video/mp4" />
                </video>
                <div className="arrows">
                  <ArrowFirst id={"leftZone"} value={attackingZones?.leftZone} />
                  <ArrowSecond id={"centralZone"} value={attackingZones?.centralZone} />
                  <ArrowThird id={"rightZone"} value={attackingZones?.rightZone} />
                </div>
              </div>
            </div>
          </div>

        </div>
      </TemplateBlock>
    </div>
  );
}
